import { memo } from 'react';
import Carousel from '@components/Carousel';
import { ILoginSlider, loginSliderData } from './Slider.model';
import SliderItem from './SliderItem';

const SliderLogin: React.FC = (): JSX.Element => {
  const settings = {
    centerPadding: '32px',
    arrows: false,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 700,
    autoplay: true,
    autoplaySpeed: 5000,
  };
  return (
    <Carousel isPromo isLoggedIn={true} {...settings}>
      {loginSliderData?.map((item: ILoginSlider, index: number) => (
        <SliderItem key={`login-slidet-item-${index}`} item={item} />
      ))}
    </Carousel>
  );
};

export default memo(SliderLogin);
